function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M4.3 10.5c0-3.5 2.8-6.3 6.3-6.3H18C17.8 1.9 15.9 0 13.5 0h-9C2.1 0 0 2 0 4.5v9c0 2.4 1.9 4.4 4.2 4.5l.1-7.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M19.5 6h-8.9v3.6h8.9c.5 0 .9.4.9.9v9c0 .5-.4.9-.9.9h-8.9c-.3 0-.5-.1-.6-.3-.1-.1-.3-.3-.3-.6v-9c0-.5.4-.9.9-.9V6c-2.5 0-4.5 2-4.5 4.5v9c0 2.5 2 4.5 4.5 4.5h8.9c2.5 0 4.5-2 4.5-4.5v-9C24 8 22 6 19.5 6z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(-.924 12.667 13.056) scale(1.00003)",
  className: "st1",
  cx: 12.7,
  cy: 13.1,
  r: 1.2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M16.8 14.1c-.2-.4-.6-.4-.9 0l-1 1.7c-.1.2-.4.2-.6.1l-.3-.4c-.2-.2-.5-.2-.7 0l-1.6 1.7c-.5.5-.3.9.4.9h6.2c.5 0 .7-.4.4-.8l-1.9-3.2z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgComponent;